import { useState } from 'react'
// import { ethers } from 'ethers'
import { fetchMaticToUsd } from './fetchMaticToUsdPrice'

export const useTokenCalculation = () => {
  const [samsTokens, setSamsTokens] = useState(0)
  const maticPriceInUSD = fetchMaticToUsd().maticPriceInUSD
  const [maticAmountInUSD, setMaticAmountInUSD] = useState(0)

  const handleAmountChange = (e) => {
    const enteredAmount = e.target.value
    const privateSalePrice = 0.005
    const amountOfMAtic = enteredAmount
    const samsToken = amountOfMAtic / privateSalePrice
    setSamsTokens(samsToken)
    const convertedAmount = (enteredAmount * maticPriceInUSD).toFixed(3)
    setMaticAmountInUSD(convertedAmount)
  }

  return [samsTokens, maticAmountInUSD, handleAmountChange]
}
